module.exports = __webpack_public_path__ + "cd710dbb5f28536d2ad33a62a07f8f3e.png";